export const arrayToggle = <Item>(array: Item[], item: Item): Item[] => {
  return array.includes(item)
    ? array.filter((i) => i !== item)
    : [...array, item];
};
